
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import { saveAs } from 'file-saver'
import util from '@/utils/busi/util'
import setting from '@/settings'
import { getHelpList, getHelpListCount, detail, enable, disable, deleteHelp, top, notTop } from '@/api/help'
import dayjs from 'dayjs'
import { MessageBox } from 'element-ui'
import { checkPermission } from '@/utils/permission'
@Component({
  name: 'help-center',
  components: {
    SimpleTable,
    DictSelect
  }
})
export default class HelpCenter extends Vue {
  private form = {
    title: '',
    state: -1
  }

  get stateDisabled () {
    return checkPermission(['helpEnable', 'helpDisable'])
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'title',
    label: '标题'
  },
  {
    prop: 'isTopName',
    label: '是否置顶'
  },
  {
    prop: 'createName',
    label: '创建人'
  },
  {
    prop: 'createTime',
    label: '创建时间',
    format: 'date'
  },
  {
    prop: 'stateName',
    label: '状态',
    custom: !0
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  get isEmpty () {
    return this.detailData.content.replace(/<[^>]*>|/g, '').trim().length < 1
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const form = util.trimForm({ ...this.form })
    !pagination && (this.pagination.currentPage = 1)
    await getHelpList({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      await getHelpListCount({
        ...form
      }).then((resCnt: any) => {
        this.loading = !1
        this.tableData.list = res.object.list
        this.tableData.totalCount = resCnt.object.totalCount
      }).catch((err: any) => {
        console.log('err', err)
        this.loading = !1
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      title: '',
      state: -1
    }
    this.onQuery()
  }

  private currentPage = 1

  private visible = !0

  private detailData: any = {}

  private async showDetail (row: any) {
    await detail({ id: row.id }).then((res: any) => {
      if (res.code === 10000) {
        this.visible = !1
        this.detailData = {
          id: res.object.help.id,
          title: res.object.help.title,
          content: res.object.help.content,
          createName: res.object.help.createName,
          isTopName: res.object.help.isTopName,
          createTime: dayjs(res.object.help.createTime).format('YYYY-MM-DD'),
          stateName: res.object.help.stateName,
          helpAtts: res.object.help.helpAtts
        }
      }
    })
  }

  private async change (row: any) {
    if (row.state === 1) {
      row.state = 0
      MessageBox.confirm(
        '确认要启用吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
        enable({ id: row.id })
        row.state = 1
      }).catch((e) => {
        console.log(e)
      })
    } else {
      row.state = 1
      MessageBox.confirm(
        '确认要禁用吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
        disable({ id: row.id })
        row.state = 0
      }).catch((e) => {
        console.log(e)
      })
    }
  }

  private selectedRow: any[] = []

  private selectionChange (selected: any) {
    this.selectedRow = selected
  }

  private async onRemove () {
    // 重置代码
    if (!this.selectedRow || this.selectedRow.length === 0) {
      this.$alert('请选择数据')
      return
    }
    MessageBox.confirm(
      '提示：您确认要删除吗？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
      const ids = this.selectedRow.map((v: any) => v.id)
      await deleteHelp({
        ids: ids.join(',')
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
          this.onQuery()
        }
      })
    })
  }

  private async top (row: any) {
    if (row.isTop === 1) {
      await notTop({
        id: row.id
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
          this.onQuery()
        }
      })
    } else {
      await top({
        id: row.id
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
          this.onQuery()
        }
      })
    }
  }

  private async downLoad (file: any) {
    saveAs(setting.ossIp + '/' + file.path, file.realName)
  }

  mounted () {
    this.onQuery()
  }
}
